import React, { useEffect, useRef } from "react";

const AreaSplineChart = ({ categories, assigned, passed, failed }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!categories || !categories.length) return;
    if (!window.Highcharts) {
      console.error("Highcharts is not loaded.");
      return;
    }

    const areaSplineChart = window.Highcharts.chart(chartRef.current, {
      chart: {
        type: "areaspline",
        backgroundColor: " rgb(248, 248, 248)",
      },

      exporting: {
        enabled: false,
      },
      title: {
        text: "",
      },
      legend: {
        layout: "horizontal", // Horizontal layout for bottom legends
        align: "center", // Center align horizontally
        verticalAlign: "bottom", // Position at the bottom
        x: 0, // No offset needed
        y: 0,
        floating: false, // Not floating — stays at bottom outside plot area
        borderWidth: 0, // Optional: remove border
      },
      xAxis: {
        categories, // dynamic months
        title: {
          text: "Month",
        },
      },
      yAxis: {
        title: {
          text: "Count",
        },
      },
      tooltip: {
        enabled: false,
      },

      credits: {
        enabled: false,
      },
      plotOptions: {
        areaspline: {
          fillOpacity: 0.5,
          stacking: "normal",
          dataLabels: {
            enabled: false,
          },
          marker: {
            enabled: false,
          },
        },
      },

      series: [
        {
          name: "Assigned",
          color: "#F01E1E",
          fillColor: {
            linearGradient: [0, 0, 0, 300], // vertical gradient
            stops: [
              [0, "rgba(138, 17, 17, 0.6)"], // top of area
              [1, "rgba(240, 30, 30, 0.7)"], // bottom of area
            ],
          },
          data: assigned,
        },
        {
          name: "Passed",
          color: "#001628",
          fillColor: {
            linearGradient: [0, 0, 0, 300], // vertical gradient
            stops: [
              [0, "rgba(0, 22, 40, 0.6)"], // top of area
              [1, "rgba(0, 78, 142, 0.7)"], // bottom of area
            ],
          },
          data: passed,
        },
        {
          name: "Failed",
          color: "#FFA500",
          fillColor: {
            linearGradient: [0, 0, 0, 300],
            stops: [
              [0, "rgba(255, 165, 0, 0.6)"],
              [1, "rgba(255, 200, 0, 0.7)"],
            ],
          },
          data: failed,
        },
      ],
    });
    return () => {
      areaSplineChart.destroy();
    };
  }, [categories, assigned, passed, failed]);

  return <div ref={chartRef} style={{ marginLeft: "-19px" }} />;
};

export default AreaSplineChart;
